export const CurrencyMap = {
  USD: '$'
};

export const FullCurrencyMap = {
  USD: 'US$'
};
